import React, { useState } from "react";
import { ChevronDown, ChevronUp } from "lucide-react";

const DataSection = ({ title, headers, data }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  // For mobile view, we'll show a collapsed version with toggle
  const toggleExpand = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <div className="bg-white p-4 md:p-6 rounded-lg shadow-md mb-6">
      <div 
        className="flex justify-between items-center cursor-pointer md:cursor-default"
        onClick={toggleExpand}
      >
        <h2 className="text-[#4C4D5E] text-xl font-semibold">
          {title}
        </h2>
        <div className="flex items-center md:hidden">
          <span className="text-sm text-gray-500 mr-2">
            {data.length} entries
          </span>
          {isExpanded ? 
            <ChevronUp className="h-5 w-5 text-gray-500" /> : 
            <ChevronDown className="h-5 w-5 text-gray-500" />
          }
        </div>
      </div>

      {/* Desktop view - always visible on larger screens */}
      <div className="hidden md:block mt-6">
        <div className="overflow-x-auto">
          <table className="min-w-full">
            <thead>
              <tr>
                {headers.map((header, index) => (
                  <th
                    key={index}
                    className="p-3 md:p-4 text-left bg-gray-50 text-[#4C4D5E] border-b text-sm font-semibold whitespace-nowrap"
                  >
                    {header}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {data.map((row, index) => (
                <tr key={index} className="hover:bg-gray-50">
                  {row.map((cell, cellIndex) => (
                    <td
                      key={cellIndex}
                      className="p-3 md:p-4 text-[#4C4D5E] border-b text-sm"
                    >
                      {cellIndex === headers.length - 1 && cell.length > 50
                        ? `${cell.substring(0, 50)}...`
                        : cell}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {/* Mobile view - collapsible list */}
      <div className={`md:hidden mt-4 ${isExpanded ? 'block' : 'hidden'}`}>
        <div className="space-y-4">
          {data.slice(0, 5).map((row, rowIndex) => (
            <div key={rowIndex} className="border rounded-lg p-3 text-sm">
              {headers.map((header, headerIndex) => (
                <div key={headerIndex} className="flex py-1 border-b last:border-b-0">
                  <div className="font-medium w-1/3 text-[#4C4D5E]">{header}:</div>
                  <div className="w-2/3 break-words">
                    {row[headerIndex] && row[headerIndex].length > 80
                      ? `${row[headerIndex].substring(0, 80)}...`
                      : row[headerIndex]}
                  </div>
                </div>
              ))}
            </div>
          ))}
          {data.length > 5 && (
            <div className="text-center text-sm text-gray-500 italic">
              {data.length - 5} more entries not shown. View on larger screen for complete data.
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default DataSection;